import { useFormik } from 'formik'
import { VAS_STATUSES } from 'Schemas/constants'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import { isValidHttpUrl } from 'Utility/validatorForm'

const STATUS_DISABLED = 'Disabled'

const buildUrlSchema = (errorMessage) =>
  Yup.string().test(
    'valid-http-url',
    errorMessage,
    (value) => isValidHttpUrl(value)
  )

const useManageVasForm = ({ onSubmit, initialValues, validationContext }) => {
  const normalizedInitialValues = initialValues || {}
  const intl = useIntl()
  const urlFormatError = intl.formatMessage({ id: 't.app.terminalsManagement.terminalConfiguration.requestorURL.error', defaultMessage: 'Enter a valid format' })
  const requiredError = intl.formatMessage({
    id: 't.app.project.error.isRequired',
    defaultMessage: 'This field is required'
  })
  const urlsMustMatchError = intl.formatMessage({ id: 't.app.terminalsManagement.vasConfiguration.scof.urlsMustMatch', defaultMessage: 'Confirmed URL must mirror the original -- please ensure identical Base URLs' })
  const isBaseUrlTokenization = validationContext?.isBaseUrlTokenization || false
  const isNotificationUrlTokenization = validationContext?.isNotificationUrlTokenization || false
  const isClickToPayBaseUrl = validationContext?.isClickToPayBaseUrl || false
  const hasTermsAccepted = Object.prototype.hasOwnProperty.call(normalizedInitialValues, 'termsAccepted')

  const validationShape = {
    status: Yup.string()
      .oneOf(VAS_STATUSES)
      .required()
      .test(
        'status-not-disabled',
        'status-not-disabled',
        (value) => !isNotificationUrlTokenization || value !== 'Disabled'
      )
  }

  if (hasTermsAccepted) {
    validationShape.termsAccepted = Yup.boolean().oneOf([true]).required()
  }
  if (isBaseUrlTokenization || isNotificationUrlTokenization || isClickToPayBaseUrl) {
    const subscriptionParamsShape = {}

    if (isNotificationUrlTokenization) {
      subscriptionParamsShape.TokenizationByCardSchemeLifecycleNotificationUrl =
        buildUrlSchema(urlFormatError)
    }

    if (isClickToPayBaseUrl) {
      subscriptionParamsShape.ClickToPayBaseUrl = buildUrlSchema(urlFormatError).required(requiredError)
    }

    if (isBaseUrlTokenization) {
      subscriptionParamsShape.TokenizationByCardSchemeBaseUrl = buildUrlSchema(
        urlFormatError
      ).required(requiredError)
      subscriptionParamsShape.ConfirmTokenizationByCardSchemeBaseUrl = Yup.string()
        .required(requiredError)
        .concat(buildUrlSchema(urlFormatError))
        .test(
          'matches-base-url',
          urlsMustMatchError,
          function (value) {
            return value === this.parent?.TokenizationByCardSchemeBaseUrl
          }
        )
    }

    validationShape.subscriptionParams = Yup.object(subscriptionParamsShape)
  }

  const validationSchema = Yup.object(validationShape)

  const formInitialValues = {
    status: normalizedInitialValues?.status || STATUS_DISABLED,
    ...normalizedInitialValues
  }

  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema,
    onSubmit: (values) => {
      onSubmit?.(values)
    }
  })
  return formik
}

export default useManageVasForm
